import * as React from 'react';
import { isNil } from 'ramda';
import { InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import TextField from '@mui/material/TextField';

type EditableInputTypeAttribute = 'text' | 'password';

interface Props {
  placeholder?: string;
  inputExistingText?: string;
  inputTypeAttribute?: EditableInputTypeAttribute;
  onChange?: (e: string) => void;
  validateError?: any;
}

interface State {
  showPassword?: boolean;
}

class EditableTextField extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = { showPassword: false };
  }

  inputOnChange = (e: any) => {
    const { onChange } = this.props;
    if (!isNil(onChange)) {
      onChange(e.target.value);
    }
  };

  handleClickShowPassword = () => {
    const { showPassword } = this.state;
    this.setState({ showPassword: !showPassword });
  };

  render() {
    const {
      placeholder,
      inputExistingText,
      inputTypeAttribute,
      validateError
    } = this.props;
    const { showPassword } = this.state;
    const inputType = inputTypeAttribute ? inputTypeAttribute : 'text';
    return (
      <React.Fragment>
        <div>
          <p>{placeholder} </p>
          <TextField
            type={showPassword ? 'text' : inputType}
            name="name"
            value={inputExistingText}
            onChange={this.inputOnChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => this.handleClickShowPassword()}
                    edge="end"
                  >
                    {showPassword ? (
                      <VisibilityOff />
                    ) : (
                      <Visibility />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
        {validateError && (
          <span>{validateError}</span>
        )}
      </React.Fragment>
    );
  }
}

export default EditableTextField;
